function ErrorComponent() {
    return(
        <div className={`text-center my-5 py-3`}>
            <h1>صفحه مورد نظر شما یافت نشد!!</h1>
            <h1>404</h1>
        </div>
    )
}

export default ErrorComponent